import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth, roleLoginPath } from "@/hooks/useAuth";
import type { CoachRole } from "@/mocks/aiCoach";

interface RequireRoleProps {
  role: CoachRole;
  children: ReactNode;
}

// Özel (giriş gerektiren) paneller için koruma katmanı.
// Oturum yoksa ya da rol eşleşmiyorsa ilgili role ait giriş sayfasına yönlendirir.
export default function RequireRole({ role, children }: RequireRoleProps) {
  const { user, role: currentRole, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background-100">
        <div className="flex items-center gap-3 text-sm text-foreground-500">
          <i className="ri-loader-4-line animate-spin text-xl" aria-hidden="true"></i>
          Yükleniyor...
        </div>
      </div>
    );
  }

  if (!user || currentRole !== role) {
    return <Navigate to={roleLoginPath(role)} replace />;
  }

  return <>{children}</>;
}